import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import {RouterLinks} from '@core/constants/routes.constants';

@Injectable({
  providedIn: 'root'
})
export class GameGuard  {
  constructor(
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const eventId = localStorage.getItem('eventId');
    if (eventId) {
      this.router.navigate([RouterLinks.GAME, eventId]);
      return false;
    }
    return true;
  }
}
